import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Catalogue from "@/pages/Catalogue";
import BusinessDetail from "@/pages/BusinessDetail";
import Conseils from "@/pages/Conseils";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import SellerDashboard from "@/pages/SellerDashboard";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import SoldDeals from "@/pages/SoldDeals";
import Contact from "@/pages/Contact";
import DiscoveryCall from "@/pages/DiscoveryCall";
import OnsiteSession from "@/pages/OnsiteSession";
import Account from "@/pages/Account";
import Article from "@/pages/Article";
import Reprendre from "@/pages/Reprendre";
import { DiscoveryFloatingButton } from "@/components/DiscoveryCTA";
import ProtectedRoute from "@/components/ProtectedRoute";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/catalogue" element={<Catalogue />} />
      <Route path="/entreprise/:id" element={<BusinessDetail />} />
      <Route path="/conseils" element={<Conseils />} />
      <Route path="/conseils/:slug" element={<Article />} />
      <Route path="/reprendre-une-entreprise" element={<Reprendre />} />
      <Route path="/entreprises-vendues" element={<SoldDeals />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/rdv-decouverte" element={<DiscoveryCall />} />
      <Route path="/connexion" element={<Auth mode="login" />} />
      <Route path="/inscription" element={<Auth mode="register" />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/vendeur" element={<ProtectedRoute role="seller"><SellerDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute role="admin"><Admin /></ProtectedRoute>} />
      <Route path="/mon-compte" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/admin/rdv" element={<ProtectedRoute role="admin"><OnsiteSession /></ProtectedRoute>} />
      <Route path="/mentions-legales" element={<Legal type="mentions" />} />
      <Route path="/politique-de-confidentialite" element={<Legal type="confidentialite" />} />
      <Route path="/cgv" element={<Legal type="cgv" />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <DiscoveryFloatingButton />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
